import { gql } from 'graphql-request';

const archiveUserAudiobook = gql`
  mutation ArchiveUserAudiobook($audiobookId: ID!) {
    archiveUserAudiobook(audiobookId: $audiobookId) {
      userAudiobook {
        id
      }
    }
  }
`;

const archiveUserAudiobooks = gql`
  mutation ArchiveUserAudiobooks($audiobookIds: [ID!]!) {
    archiveUserAudiobooks(audiobookIds: $audiobookIds) {
      userAudiobooks {
        id
      }
    }
  }
`;

const markAudiobookFinished = gql`
  mutation MarkFinishedMutation($id: ID!) {
    markAudiobookFinished(id: $id) {
      userAudiobook {
        id
      }
    }
  }
`;

const markAudiobooksFinished = gql`
  mutation MarkFinishedMutation($audiobookIds: [ID!]!) {
    markAudiobooksFinished(audiobookIds: $audiobookIds) {
      userAudiobooks {
        id
      }
    }
  }
`;

const markAudiobookUnfinished = gql`
  mutation MarkUnfinishedMutation($id: ID!) {
    markAudiobookUnfinished(id: $id) {
      userAudiobook {
        id
      }
    }
  }
`;

const unarchiveUserAudiobooks = gql`
  mutation unarchiveUserAudiobooks($audiobookIds: [ID!]!) {
    unarchiveUserAudiobooks(audiobookIds: $audiobookIds) {
      userAudiobooks {
        id
      }
    }
  }
`;

const updateUserAudiobookPosition = gql`
  mutation UpdateUserAudiobookPosition($audiobookId: ID!, $currentOverallOffsetMs: Int!, $recordedAt: String!) {
    updateUserAudiobookPosition(
      audiobookId: $audiobookId
      currentOverallOffsetMs: $currentOverallOffsetMs
      recordedAt: $recordedAt
    ) {
      userAudiobook {
        id
        currentOverallOffsetMs
      }
    }
  }
`;

export const userAudiobookMutations = {
  archiveUserAudiobook,
  archiveUserAudiobooks,
  markAudiobookFinished,
  markAudiobooksFinished,
  markAudiobookUnfinished,
  unarchiveUserAudiobooks,
  updateUserAudiobookPosition,
};
